(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-seo"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      const roots = document.querySelectorAll('[data-seo-faq-root]');

      function setOpenState(item, isOpen) {
        item.classList.toggle('is-open', isOpen);
        const button = item.querySelector('.nv-collection-seo__faq-question');
        if (button) {
          button.setAttribute('aria-expanded', String(isOpen));
        }
      }

      roots.forEach((root) => {
        if (root.dataset.enhanced === 'true') return;

        const source = root.querySelector('[data-seo-faq-source]');
        const target = root.querySelector('[data-seo-faq-list]');

        if (!source || !target) return;

        const paragraphs = [...source.querySelectorAll('p')].filter((paragraph) => paragraph.textContent.trim() !== '');
        const items = [];

        for (let index = 0; index < paragraphs.length; index += 1) {
          const questionNode = paragraphs[index];
          const strong = questionNode.querySelector('strong');
          const question = strong?.textContent?.trim();

          if (!question || questionNode.textContent.trim() !== question) continue;

          const answerNode = paragraphs[index + 1];
          items.push({
            question,
            answerHtml: answerNode?.innerHTML || '',
          });

          if (answerNode) index += 1;
        }

        if (!items.length) return;

        const fragment = document.createDocumentFragment();

        items.forEach((item) => {
          const wrapper = document.createElement('div');
          wrapper.className = 'nv-collection-seo__faq-item';

          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'nv-collection-seo__faq-question';
          button.setAttribute('aria-expanded', 'false');

          const label = document.createElement('span');
          label.textContent = item.question;

          const icon = document.createElement('span');
          icon.className = 'nv-collection-seo__faq-icon';
          icon.setAttribute('aria-hidden', 'true');

          const answer = document.createElement('div');
          answer.className = 'nv-collection-seo__faq-answer';

          const answerInner = document.createElement('div');
          answerInner.className = 'nv-collection-seo__faq-answer-inner';
          answerInner.innerHTML = item.answerHtml;

          answer.append(answerInner);
          button.append(label, icon);
          wrapper.append(button, answer);
          fragment.append(wrapper);
        });

        target.append(fragment);
        target.hidden = false;
        source.classList.add('is-enhanced');
        root.dataset.enhanced = 'true';

        target.addEventListener('click', (event) => {
          const button = event.target.closest('.nv-collection-seo__faq-question');
          if (!button) return;

          const currentItem = button.closest('.nv-collection-seo__faq-item');
          const shouldOpen = !currentItem.classList.contains('is-open');

          target.querySelectorAll('.nv-collection-seo__faq-item').forEach((item) => {
            setOpenState(item, item === currentItem ? shouldOpen : false);
          });
        });
      });
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
